import { LaneSource } from "@redotech/cockroachdb-codegen/tables/returns/lane-source";
import * as z from "zod";

export const laneOutput = z.object({
  id: z.string(),
  originCountry: z.string(),
  destinationCountry: z.string(),
  source: z.nativeEnum(LaneSource),
});
